module.exports = __webpack_public_path__ + "img/avisolar_transparent.8b5eeb63.png";